import { NgClass } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, WritableSignal, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { Subscription } from "rxjs";
import { SwipeData } from "@src/app/models/interfaces/swipeData.interface";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { ImageService } from "../../servicios/image/image.service";
import { GaleriaSliderComponent } from "../galeria-slider/galeria-slider.component";

@Component({
  selector: "app-full-image-viewer",
  templateUrl: "./full-image-viewer.component.html",
  styleUrls: ["./full-image-viewer.component.css"],
  imports: [NgClass, GaleriaSliderComponent, MatButtonModule, MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullImageViewerComponent implements OnInit, OnDestroy {
  imagenes: string[] = [];
  numeroImagenes: number = 0;
  imgsSuscripcion: Subscription;
  imgSuscripcion: Subscription;
  imgSeleccionada = signal("test");
  fade: WritableSignal<boolean> = signal(true);
  isMobile: boolean;
  restantes: string;
  isImg: boolean = true;
  private swipeData: SwipeData = {};

  @Input() show: boolean;
  @Input() urlVideo: string;
  @Input() noticia;

  @Output() close = new EventEmitter<boolean>();
  @Output() closeVideo = new EventEmitter();

  constructor(
    private imageService: ImageService,
    private platformService: PlatformService,
  ) {}

  /**
   * La función ngOnDestroy cancela la suscripción de una suscripción de imagen.
   */
  ngOnDestroy(): void {
    if (this.imgsSuscripcion) this.imgsSuscripcion.unsubscribe();
    if (this.imgSuscripcion) this.imgSuscripcion.unsubscribe();
  }

  /**
   * Inicializa algunas variables y se suscribe a un servicio de imágenes para
   * actualizar la imagen seleccionada.
   */
  ngOnInit(): void {
    this.imgsSuscripcion = this.imageService.getImagenes().subscribe((imgs) => {
      this.imagenes = imgs;
      this.numeroImagenes = this.imageService.getNumImagenes();
    });
    this.numeroImagenes = this.imageService.getNumImagenes();
    this.imgSuscripcion = this.imageService.getSeleccionada().subscribe((img) => {
      if (img === this.imgSeleccionada()) return;
      this.fade.set(false);
      if (img === null) return;
      if (this.platformService.isBrowser()) {
        setTimeout(() => {
          this.fade.set(true);
          this.imgSeleccionada.set(img);
        }, 200);
      }
    });
    this.imgSeleccionada.set(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.show) {
      if (this.show === true) {
        // this.esVideo();
        /*    this.imageService.getSeleccionada().subscribe((img) => {
            this.imgSeleccionada = img;
        }).unsubscribe(); */
      }
    }
  }

  /**
   * La función "cerrarViewer" emite "close" con valor falso.
   */
  cerrarViewer() {
    this.imgSeleccionada.set(null);
    this.close.emit(false);
  }
  /**
   * La función "cerrarViewer" emite "close" con valor falso.
   */
  cerrarViewerVideo() {
    this.cerrarViewer();
    this.closeVideo.emit();
  }

  /**
   * La función `cerrarClickFuera` comprueba si el elemento pulsado tiene un nombre de clase específico
   * y cierra un visor si lo tiene.
   * @param {Event} event - El parámetro de evento es un objeto que representa el evento que activó la
   * función. Contiene información sobre el evento, como el elemento de destino que activó el evento.
   */
  cerrarClickFuera(event: Event) {
    let className: string;

    if (typeof event.target["className"] === "string") {
      className = event.target["className"];
    }
    if (event.target["className"] instanceof SVGAnimatedString) {
      className = event.target["className"].baseVal;
    }
    if (className.includes("fullScreenContainer")) {
      this.cerrarViewer();
    }
  }

  /**
   * La función llama al método `getImgSiguiente()` desde el objeto `imageService`.
   * Utilizado como función para el botón de pasar imagen.
   */
  siguiente(): void {
    this.imageService.getImgSiguiente();
  }

  /**
   * La función llama al método `getImgAnterior()` del objeto `imageService`.
   * *Utilizado como función para el botón de imagen anterior.
   **/
  anterior(): void {
    this.imageService.getImgAnterior();
  }

  /**
   * La función `swipe` detecta gestos de deslizamiento y realiza acciones en función de la dirección y
   * la velocidad del deslizamiento.
   * @param {TouchEvent} e - TouchEvent: el objeto de evento táctil que contiene información sobre el
   * evento táctil.
   * @param {string} when - El parámetro "cuando" es una cadena que especifica cuándo ocurrió el evento
   * de deslizamiento. Puede tener dos valores posibles: "inicio" o "fin".
   */
  swipe(e: TouchEvent, when: string): void {
    const [x, y] = [e.changedTouches[0].clientX, e.changedTouches[0].clientY];
    const tiempoInicial = new Date().getTime();

    if (when === "start") {
      this.swipeData.swipeCoord = [x, y];
      this.swipeData.swipeTime = tiempoInicial;
    } else if (when === "end") {
      const [desplHoriz, desplVert] = [x - this.swipeData.swipeCoord[0], y - this.swipeData.swipeCoord[1]];
      const tiempoTotal = tiempoInicial - this.swipeData.swipeTime;

      if (tiempoTotal < 1500 && Math.abs(desplHoriz) > 30 && Math.abs(desplHoriz) > Math.abs(desplVert) * 3) {
        if (desplHoriz < 0) {
          this.siguiente();
        } else {
          this.anterior();
        }
      }
    }
  }

  /**
   * La función `esVideo` verifica si el índice actual es 0 y si hay una URL de video, y establece la
   * variable `isImg` en consecuencia.
   * @returns Si la condición `this.imageService.getIndexActual() === 0 && this.urlVideo` es verdadera,
   * entonces se devuelve `false`. De lo contrario, se devuelve `true`.
   */
  /* esVideo(){
      
      this.isImg = true
  } */
}
